import React from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import { findUrlForMedia } from "../utils";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

export default function Carousel ({ block, autoplay = true }) {
  const slickSettings = {
    dots: true,
    fade: true,
    infinite: true,
    speed: 1000,
    autoplay,
    lazyload: "ondemand",
    slidesToShow: 1,
    arrows: false,
    draggable: false,
    slidesToScroll: 1,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 1080,
        appendDots: null,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
          draggable: true
        }
      }
    ]
  };
  const entries = block.data.entries.map(e => ({
    src: findUrlForMedia(e.media, e.format),
    to: e.to
  }));

  return (
    <div className="carouselContainer">
      <Slider {...slickSettings}>
        {entries.map((e, i) => (
          <React.Fragment key={i}>
            {e.to && typeof e.to === "string" ? (
              <>
                {e.to.includes("http") ? (
                  <a href={e.to} target="_blank" rel="noopener noreferrer">
                    <img key={e.src} src={e.src} alt={`Carousel entry ${i}`} />
                  </a>
                ) : (
                  <Link to={e.to}>
                    <img key={e.src} src={e.src} alt={`Carousel entry ${i}`} />
                  </Link>
                )}
              </>
            ) : (
              <img key={e.src} src={e.src} alt={`Carousel entry ${i}`} />
            )}
          </React.Fragment>
        ))}
      </Slider>
    </div>
  );
}
